var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vx-card",
    { attrs: { title: "Button", "code-toggler": "" } },
    [
      _c("p", [
        _vm._v(
          "You can customize the component or element that initialize the dropdown in this case, it is a Button that is the most common"
        ),
      ]),
      _c(
        "vs-alert",
        {
          staticClass: "mt-5",
          attrs: { color: "primary", icon: "new_releases", active: "true" },
        },
        [
          _c("p", [
            _vm._v(
              "The component or element that initializes the dropdown is the one inside it with the possibility of total customization and flexibility in the required use"
            ),
          ]),
        ]
      ),
      _c(
        "vs-alert",
        {
          staticClass: "my-5",
          attrs: { color: "primary", icon: "new_releases", active: "true" },
        },
        [
          _c("p", [
            _vm._v(
              "Vuesax uses the Google Material Icons font library by default. For a list of all available icons, visit the official "
            ),
            _c(
              "a",
              {
                attrs: { href: "https://material.io/icons/", target: "_blank" },
              },
              [_vm._v("Material Icons page")]
            ),
            _vm._v("."),
          ]),
          _c("p", [
            _vm._v(
              "FontAwesome and other fonts library are supported. Simply use the icon-pack with fa or fas. You still need to include the Font Awesome icons in your project."
            ),
          ]),
        ]
      ),
      _c("prism", { staticClass: "rounded-lg" }, [
        _vm._v(
          "\n<vs-dropdown>\n  <!-- element that initializes the dropdown -->\n\n  <vs-dropdown-menu>\n    <!-- items and elements within the menu or custom dropdown -->\n  </vs-dropdown-menu>\n</vs-dropdown>\n        "
        ),
      ]),
      _c("div", { staticClass: "mt-5 demo-alignment" }, [
        _c(
          "div",
          { staticClass: "dropdown-button-container" },
          [
            _c(
              "vs-button",
              { staticClass: "btnx", attrs: { type: "filled" } },
              [_vm._v("Dropdown")]
            ),
            _c(
              "vs-dropdown",
              [
                _c("vs-button", {
                  staticClass: "btn-drop",
                  attrs: { type: "filled", icon: "expand_more" },
                }),
                _c(
                  "vs-dropdown-menu",
                  [
                    _c("vs-dropdown-item", [_vm._v(" option 1 ")]),
                    _c("vs-dropdown-item", [_vm._v(" option 2 ")]),
                    _c(
                      "vs-dropdown-group",
                      [
                        _c("vs-dropdown-item", [_vm._v(" option 1 ")]),
                        _c("vs-dropdown-item", [_vm._v(" option 2 ")]),
                      ],
                      1
                    ),
                    _c("vs-dropdown-item", { attrs: { divider: "" } }, [
                      _vm._v(" option 3 "),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "dropdown-button-container" },
          [
            _c(
              "vs-button",
              {
                staticClass: "btnx",
                attrs: { color: "success", type: "gradient" },
              },
              [_vm._v("Dropdown")]
            ),
            _c(
              "vs-dropdown",
              [
                _c("vs-button", {
                  staticClass: "btn-drop",
                  attrs: {
                    color: "success",
                    type: "gradient",
                    icon: "more_horiz",
                  },
                }),
                _c(
                  "vs-dropdown-menu",
                  [
                    _c("vs-dropdown-item", [_vm._v(" Home ")]),
                    _c("vs-dropdown-item", [_vm._v(" Contributors ")]),
                    _c("vs-dropdown-item", { attrs: { divider: "" } }, [
                      _vm._v(" Logout "),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "dropdown-button-container" },
          [
            _c(
              "vs-button",
              { staticClass: "btnx", attrs: { type: "line", color: "danger" } },
              [_vm._v("Icons")]
            ),
            _c(
              "vs-dropdown",
              [
                _c("vs-button", {
                  staticClass: "btn-drop",
                  attrs: { type: "line", color: "danger", icon: "mood" },
                }),
                _c(
                  "vs-dropdown-menu",
                  [
                    _c("vs-dropdown-item", [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(" mood "),
                      ]),
                    ]),
                    _c("vs-dropdown-item", [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(" mood_bad "),
                      ]),
                    ]),
                    _c("vs-dropdown-item", [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(" sentiment_dissatisfied "),
                      ]),
                    ]),
                    _c("vs-dropdown-item", [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(" sentiment_satisfied "),
                      ]),
                    ]),
                    _c("vs-dropdown-item", [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(" sentiment_very_dissatisfied "),
                      ]),
                    ]),
                    _c("vs-dropdown-item", [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(" sentiment_very_satisfied "),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("template", { slot: "codeContainer" }, [
        _vm._v(
          '\n<template>\n  <div class="demo-alignment">\n\n    <!-- Dropdown Button 1 -->\n    <div class="dropdown-button-container">\n      <vs-button class="btnx" type="filled">Dropdown</vs-button>\n\n      <vs-dropdown>\n        <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>\n        <vs-dropdown-menu>\n\n          <vs-dropdown-item> option 1 </vs-dropdown-item>\n          <vs-dropdown-item> option 2 </vs-dropdown-item>\n\n          <vs-dropdown-group>\n            <vs-dropdown-item> option 1 </vs-dropdown-item>\n            <vs-dropdown-item> option 2 </vs-dropdown-item>\n          </vs-dropdown-group>\n\n          <vs-dropdown-item divider> option 3 </vs-dropdown-item>\n        </vs-dropdown-menu>\n      </vs-dropdown>\n    </div>\n\n    <!-- Dropdown Button 2 -->\n    <div class="dropdown-button-container">\n      <vs-button class="btnx" color="success" type="gradient">Dropdown</vs-button>\n\n      <vs-dropdown>\n        <vs-button class="btn-drop" color="success" type="gradient" icon="more_horiz"></vs-button>\n        <vs-dropdown-menu>\n\n          <vs-dropdown-item> Home </vs-dropdown-item>\n          <vs-dropdown-item> Contributors </vs-dropdown-item>\n          <vs-dropdown-item divider> Logout </vs-dropdown-item>\n        </vs-dropdown-menu>\n      </vs-dropdown>\n    </div>\n\n    <!-- Dropdown Button 3 -->\n    <div class="dropdown-button-container">\n      <vs-button class="btnx" type="line" color="danger">Icons</vs-button>\n\n      <vs-dropdown>\n        <vs-button class="btn-drop" type="line" color="danger" icon="mood"></vs-button>\n        <vs-dropdown-menu>\n\n          <vs-dropdown-item>\n            <i class="material-icons"> mood </i>\n          </vs-dropdown-item>\n          <vs-dropdown-item>\n            <i class="material-icons"> mood_bad </i>\n          </vs-dropdown-item>\n          <vs-dropdown-item>\n            <i class="material-icons"> sentiment_dissatisfied </i>\n          </vs-dropdown-item>\n          <vs-dropdown-item>\n            <i class="material-icons"> sentiment_satisfied </i>\n          </vs-dropdown-item>\n          <vs-dropdown-item>\n            <i class="material-icons"> sentiment_very_dissatisfied </i>\n          </vs-dropdown-item>\n          <vs-dropdown-item>\n            <i class="material-icons"> sentiment_very_satisfied </i>\n          </vs-dropdown-item>\n        </vs-dropdown-menu>\n      </vs-dropdown>\n    </div>\n  </div>\n</template>\n\n<style lang="scss">\n.dropdown-button-container {\n  display: flex;\n  align-items: center;\n\n  .btnx {\n    border-radius: 5px 0px 0px 5px;\n  }\n\n  .btn-drop {\n    border-radius: 0px 5px 5px 0px;\n    border-left: 1px solid rgba(255, 255, 255, .2);\n  }\n}\n</style>\n        '
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }